export enum SelectionType {
  Text = 'Text',
  Node = 'Node',
}

export interface ProseMirrorSelection {
  type: SelectionType;
  anchor: number;
  head?: number;
}

export interface CommentEditorSelection {
  editorBlockId: string;
  sectionId?: string;
  rowId?: string;
  cellId?: string;
  nodeId?: string;
  textSelection?: ProseMirrorSelection;
  content?: string;
  detachedFromContent?: boolean; // when FE does EAS
  detachedFromS3Version?: boolean; // when BE does not have matching s3 version
}
